import { takeLatest, call, put } from 'redux-saga/effects'
import { createMeetingInstance } from 'api/administration/blocks/Create'
import lessonBlocksList from 'api/administration/blocks/List'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import { IMeetingBlockModel } from 'models/block.model'
import * as fromActions from '../../../actions/blocks.action'

async function handleCreateMeetingBlock(data: IMeetingBlockModel) {
  return createMeetingInstance(data)
}

async function getList(lessonId: number) {
  return lessonBlocksList(lessonId)
}

function* newMeetingBlockEffectSaga(action: any) {
  try {
    const { data } = action
    const result = yield call(handleCreateMeetingBlock, data)
    yield put(fromActions.Actions.createBlockInstanceSuccess(result))
    const {
      block_instance: { lesson_id },
    } = data
    const blocks = yield call(getList, lesson_id)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(blocks))
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* createMeetingWatcherSaga() {
  yield takeLatest(fromActions.MEETING_BLOCK_CREATE, newMeetingBlockEffectSaga)
}
